export var DriveItemType;
(function (DriveItemType) {
    DriveItemType["Folder"] = "folder";
    DriveItemType["Collection"] = "collection";
    DriveItemType["CarbonProject"] = "carbonProject";
    DriveItemType["Product"] = "product";
    DriveItemType["Url"] = "url";
    DriveItemType["Spectrum"] = "spectrum";
})(DriveItemType || (DriveItemType = {}));
